import { SecondarySideBarType3 } from "app/components/sidebar3/types";
import Home from "app/pages/activation/modules/Home/Home";
import { ACTIVATION_HOME_ROUTE, ACTIVATION_ROOT_ROUTE, ACTIVATION_HOME_URL } from "app/pages/activation/routing/constants";

import { CONFIG_ID, SECONDARY_BAR_TYPE } from "./constants";

export const homeConfig = {
    [ACTIVATION_HOME_ROUTE]: {
        parent: ACTIVATION_ROOT_ROUTE,
        url: ACTIVATION_HOME_URL,
        component: Home,
        configId: CONFIG_ID,
        configIdDeps: ["WebAnalysis", "MobileWeb", "MobileWebWorldwide"],
        pageId: {
            section: "homepage",
        },
        trackingId: {
            section: "activation homepage",
            subSection: "homepage",
            subSubSection: "activation homepage",
        },
        pageTitle: "activation.setup.page.title",
        isSecondaryBarOpen: false,
        secondaryBarType: SECONDARY_BAR_TYPE,
        secondaryBarType3: SecondarySideBarType3.Activation,
        hideSecondaryBar3: true,
        hideFromRecents: true,
        isPrimarySidebarAlwaysOpen: true,
    },
};

